import { Upload } from "antd";
import React, { useEffect, useState } from "react";
import GradientButton from "../Button/GradientButton";
import { CloudIcon, UploadFileIcon } from "../../utils/icons";
import { getS3Media } from "../../services/awsServices";
import { UploadOutlined } from "@ant-design/icons";

// type = gradient, normal
const MyFileUpload = ({
  type = "gradient",
  placeholder = "Upload",
  icon = UploadFileIcon,
  titleClass = "",
  btnClass = "",
  onChange = () => {},
  ...rest
}) => {
  const [m3Document, setM3Document] = useState([]);

  console.log(rest, "===rest.valuerest.value:m3Document");

  async function getUrls() {
    if (rest.value?.length > 0 && Array.isArray(rest.value)) {
      const data = [];
      for (let i = 0; i < rest.value?.length; i++) {
        const element = rest.value[i];
        if (!element || element?.length === 0) continue;
        const res = await getS3Media(element);
        data.push(res?.data?.url);
      }
      // getS3Media(rest.value).then((res) => {
      //   console.log(res, "==res:getS3Media");
      //   if (res) {
      //     setM3Document(res?.data?.url);
      //   }
      // });
      setM3Document(data);
    } else if (rest.value && rest.value?.length > 0) {
      const res = await getS3Media(rest.value);
      setM3Document([res?.data?.url]);
    }
  }

  const openInNewTab = (url) => {
    window.open(
      `https://docs.google.com/gview?url=${encodeURIComponent(
        url
      )}&embedded=true`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  useEffect(() => {
    getUrls();
  }, [rest.value]);

  const props = {
    name: name,
    headers: {
      authorization: "authorization-text",
    },
    accept: "image/png, image/jpeg, image/jpg, .pdf",
    // maxCount: 1,
    // listType: "picture",
    beforeUpload: () => false,
    // fileList: imageData.fileList,
    ...rest,
    onChange: ({ fileList }) => onChange(fileList),
  };

  if (type === "gradient") {
    return (
      <>
        <Upload {...props}>
          <GradientButton type="button">
            <span>{CloudIcon}</span>
            <span className="ml-3 text-base font-medium">{placeholder}</span>
          </GradientButton>
        </Upload>
      </>
    );
  }
  return (
    <div className="w-full">
      <Upload {...props} className="w-full">
        <button
          type="button"
          className={`flex justify-between items-center py-[7px] px-3 rounded-[16px] border-2 border-gray-200 hover:border-blue-500 hover:border-[1px] w-full ${btnClass}`}
        >
          <span className={`${titleClass}`}>{placeholder}</span>
          <span>{icon}</span>
        </button>
      </Upload>
      {m3Document?.length > 0 &&
        m3Document.map(
          (data) =>
            data && (
              <a
                onClick={() => openInNewTab(data)}
                target="_blank"
                rel="noopener noreferrer"
                href={data}
                key={data}
              >
                {data.slice(0, 40)}
              </a>
            )
        )}
    </div>
  );
};

export default MyFileUpload;
